import React from "react";

const containerStyle = {
  maxWidth: "900px",
  margin: "2rem auto",
  padding: "2rem",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
  fontFamily: "Segoe UI, Arial, sans-serif",
};

const titleStyle = {
  color: "#1a237e",
  fontSize: "2.4rem",
  marginBottom: "0.5rem",
  fontWeight: 700,
};

const subtitleStyle = {
  color: "#1565c0",
  fontSize: "1.3rem",
  fontStyle: "italic",
  marginBottom: "2rem",
};

const sectionTitleStyle = {
  color: "#283593",
  fontSize: "1.2rem",
  fontWeight: 600,
  margin: "2rem 0 0.5rem 0",
};

const textStyle = {
  color: "#222",
  fontSize: "1.08rem",
  lineHeight: 1.7,
  marginBottom: "1.2rem",
};

const ceoStyle = {
  background: "#e3f2fd",
  borderLeft: "4px solid #1976d2",
  padding: "1rem",
  margin: "2rem 0",
  borderRadius: "8px",
};

function About() {
  return (
    <div style={containerStyle}>
      <div style={titleStyle}>Akruthi Engineered Building Solutions</div>
      <div style={subtitleStyle}>"your imagination turns into shape"</div>
      <div style={textStyle}>
        Incorporated in the year 2013,{" "}
        <b>Akruthi Engineered Building Solution</b> is among the renowned
        Manufacturers and Service Providers of Pre Engineered Building,
        Industrial Building, Factory Shed, Mezzanine Systems, Basketball Post,
        Canopy Shed, Chain Link Fencing, Industrial Staircase, Mild Steel Lift
        Structure, Mild Steel Platforms, etc.
      </div>
      <div style={textStyle}>
        We provide turnkey solutions starting from concept, design, analysis,
        fabrication, supply, and installation. We are committed to providing the
        customer with the highest quality products and services, and are
        involved from concept to completion of every project.
      </div>
      <div style={textStyle}>
        We deliver better value for money to clients through superior
        technology. Our able, skillful, and experienced professional team
        ensures quality work execution in the field, so the client receives the
        best service by any standard.
      </div>
      <div style={textStyle}>
        We strictly follow major international design standards and engineering
        norms pertinent to the PEB industry in all projects. We welcome
        technical inquiries from customers, architects, and consultants, and are
        always ready to assist with specifications for pre-engineered building
        systems and to recommend optimal solutions to building requirements.
      </div>
      <div style={textStyle}>
        We also provide Industrial Shed Fabrication Service and Pre-Engineered
        Buildings Services to our clients.
      </div>
      <div style={sectionTitleStyle}>Management</div>
      <div style={ceoStyle}>
        <b>Our firm is managed by Mr. Prashant Kumar and Mr. Ravichandra.</b>{" "}
        They understands the importance of available resources and ensures they
        are utilized in the best possible manner for optimal results. We lay
        great emphasis on the quality of our range and ensure that the products
        we offer serve our customers’ needs in an appropriate manner.
      </div>
    </div>
  );
}

export default About;
